import { render, staticRenderFns } from "./StatusProcessamento.vue?vue&type=template&id=6d2588e0&scoped=true"
import script from "./StatusProcessamento.vue?vue&type=script&lang=js"
export * from "./StatusProcessamento.vue?vue&type=script&lang=js"
import style0 from "./StatusProcessamento.vue?vue&type=style&index=0&id=6d2588e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2588e0",
  null
  
)

export default component.exports